import { IS_ROSSUM_ENABLED } from '../../../constants';
import { routePaths } from '../../../routePaths';
import { translate } from '../../../utils';
import { RouteType } from '../../../types';
import { WarehousePermission } from '../../../generated/graphql';
import {
    CreateDeliveryListForm,
    DeliveryListDetails,
    UploadDeliveryListForm,
    VerifyDeliveryListForm,
} from '../../../modules/deliveryLists';
import DeliveryLists from './DeliveryLists';


const WarehouseDeliveryListsRoute: RouteType = {
    exact: false,
    showInSideBar: true,
    path: routePaths.warehouseDeliveryLists,
    title: translate('Delivery Lists'),
    permissions: {
        warehouse: [WarehousePermission.CanViewDeliveryList],
    },
    component: DeliveryLists,
    childrenRoutes: [
        {
            exact: true,
            path: routePaths.warehouseDeliveryListsCreate,
            component: CreateDeliveryListForm,
            title: translate('New delivery list'),
            permissions: {
                warehouse: [WarehousePermission.CanAddDeliveryList]
            },
            redirectRoute: routePaths.warehouseDeliveryLists
        },
        ...(
            IS_ROSSUM_ENABLED
                ? [
                    {
                        exact: true,
                        path: routePaths.warehouseDeliveryListsUpload,
                        component: UploadDeliveryListForm,
                        title: translate('Upload invoices'),
                        permissions: {
                            warehouse: [WarehousePermission.CanAddDeliveryList]
                        },
                        redirectRoute: routePaths.warehouseDeliveryLists
                    },
                    {
                        path: routePaths.warehouseDeliveryListsVerify,
                        component: VerifyDeliveryListForm,
                        title: translate('Verify delivery list'),
                        permissions: {
                            warehouse: [WarehousePermission.CanAddDeliveryList]
                        },
                        redirectRoute: routePaths.warehouseDeliveryLists
                    },
                ]
                : []
        ),
        {
            path: routePaths.warehouseDeliveryListsDetails,
            component: DeliveryListDetails,
            title: translate('Delivery list'),
            permissions: {
                warehouse: [WarehousePermission.CanViewDeliveryList]
            },
            redirectRoute: routePaths.warehouseDeliveryLists,
        },
    ],
};

export default WarehouseDeliveryListsRoute;
